export default __webpack_public_path__ + "assets/images/OtsuVisualization-7063df3673183c1b23d169e2243d3420.png";